module.exports = __webpack_public_path__ + "static/img/sorry.f97510f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sorry.png
// module id = 75
// module chunks = 1